/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const PubNubMessageAction = core.serialization.object({
    uuid: core.serialization.string(),
    actionTimetoken: core.serialization.string(),
});
